import {
  type ParentBreadcrumb,
  type SectionConfig
} from '@/utils/get-matched-section'

const dictionaryParent: ParentBreadcrumb = {
  label: 'Dictionary',
  href: (_params, orgSlug) => `/${orgSlug}/metrics/dictionary`
}

export const sectionConfig: SectionConfig = {
  '/metrics/dictionary': {
    title: 'Metrics Dictionary',
    showBreadcrumbs: false
  },
  '/metrics/dictionary/[metricId]': {
    title: 'Metric',
    parentBreadcrumb: dictionaryParent
  },
  '/metrics/explorer': {
    title: 'Metrics Explorer'
  },
  '/metrics/okrs': {
    title: 'OKRs'
  },
  '/metrics/sign-offs': {
    title: 'Metric Sign-offs'
  },
  '/metrics/history': {
    title: 'History Capture'
  }
}
